/**
 * 最終処分報告取消
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/rest_manifests`

const rest_manifest_final_disposal = {

  namespaced: true,
  actions: {
    /**
     * 紙・Web最終処分報告の取消
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    delete ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/final_disposals`
        Vue.$http.delete(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '取消しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default rest_manifest_final_disposal
